import { ActionList, Divider } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { Appearance } from "./Appearance";
import { BetaCommunity } from "./BetaCommunity";
import { LanguageSettings } from "./LanguageSettings";
import { AppTitle } from "../../../components/AppTitle";
import { useDocumentTitle } from "../../../hooks/api/useDocumentTitle";

export function PreferencesPage() {
  const { t } = useTranslation();
  useDocumentTitle(`Certn ${t("Preferences")}`);

  return (
    <>
      <AppTitle title={t("Preferences")} />
      <ActionList ariaLabel={t("Preferences")}>
        <LanguageSettings />
        <Divider />
        <Appearance />
        <Divider />
        <BetaCommunity />
      </ActionList>
    </>
  );
}
